import {
  UPLOAD_ICON_LOADING,
  UPLOAD_ICON_SUCCESS,
  UPLOAD_ICON_FAIL,
  DELETE_ICON_LOADING,
  DELETE_ICON_SUCCESS,
  DELETE_ICON_FAIL,
  FETCH_ICON_FAIL,
  SET_ICON
} from '../actions/types';

const INITIAL_STATE = {
  loading: false,
  seekcity: '',
  seekcityvisited: '',
};

const StorageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
      case UPLOAD_ICON_LOADING:
        return { ...state, loading: true }
      case UPLOAD_ICON_SUCCESS: {
        return { ...state, loading: false }
      }
      case UPLOAD_ICON_FAIL: {
        return { ...state, loading: false }
      }
      case SET_ICON: {
        return { ...state, [action.payload.prop]: action.payload.icon }
      }
      case DELETE_ICON_LOADING: 
        return { ...state, loading: true }
      case DELETE_ICON_FAIL:   
        return { ...state, loading: false }
      case DELETE_ICON_SUCCESS: 
        return { ...state, loading: false, [action.payload]: '' }
      case FETCH_ICON_FAIL:
        return { ...INITIAL_STATE,  }
      default:
          return state;
  }
};

export default StorageReducer;